

export interface OperationBase<ObjectIdType = string> {
    _id?: ObjectIdType,
    equipment: string,
    product?: string,
    partDisplayName?: string;//undefined if created in offline mode; persisted because of search
    effectiveTime: Date,//The time that the operation applies at. May be different from the createdAt time, when adding operation to batch after it ends.
    createdAt: Date,
    modifiedAt: Date,
    partCount?: number,
    comment?: string,
    confirmedScraps?: number | null,// Initial confirmed scraps. Final value is affected by other fields.
    potentialScraps?: number | null,// Initial potential scraps. Final value is affected by other fields.
    orderNumber?: string,
    operator?: string,//field was added after the initial implementation
    cycleTimeOverall: CycleTimeInfo | null,
    cycleTimeRecent: CycleTimeInfo | null,
    recordId?: ObjectIdType,
    details: string[],
    scrapReview?: ScrapReview,
    scrapCloseForm?: ScrapCloseForm,
    scrapHandledAt?: Date,// Scrap case handled time which may be from the scrapReview or scrapCloseForm.

    //Individual fields for the details array
    operationType: string,
    machineComponent?: string,
    machineMainComponent?: string,
    plusOrMinus?: string,
    adjustmentText?: string,
    toolVariant?: string,
    toolNumber?: string,
    isScheduled?: string,
    dimension?: string,
    offset?: number,
    toolFailReason?: string,
    toolBreakReason?: string,
    programEditText?: string,
    numIssues?: number,
    collateralDamage?: Tool[],
    fixedTools?: Tool[],
}

export type OperationFront = OperationBase<string> & {
    equipmentDisplayName: string;
};


export interface Tool {
    toolVariant: string,
    toolNumber: string,
}

export interface CycleTimeInfo {
    cycleTimeMedian: number;
    numParts: number;
}

export interface ScrapReview {
    result: ScrapReviewResult;
    comment: string;
    scrapReason?: ScrapReason;
    operator: string;
    time?: Date;
}

export type ScrapReviewResult = 'release' | 'scrap' | 'inspect';

export const ScrapReasons = [
    { label: 'Out of tolerance' as const, isHidden: false },
    { label: 'Thread bad' as const, isHidden: false },
    { label: 'Thread missing' as const, isHidden: false },
    { label: 'Cut-off pin' as const, isHidden: false },
    { label: 'Surface quality' as const, isHidden: false },
    { label: 'Chips/burrs' as const, isHidden: false },
    { label: 'Missing feature' as const, isHidden: false },
    { label: 'Other' as const, isHidden: true },
];
export type ScrapReason = (typeof ScrapReasons)[number]['label'];

export interface ScrapCloseForm {
    addedConfirmedScrap: number;
    scrapReason?: ScrapReason;
    comment: string;
    operator: string;
    time?: Date;
    timeSpent?: number;
}
